/**
 * Responsavel
 * @author Simpli CLI generator
 */
import {ResponseSerialize} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'

export class ResponsavelResponse {
  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  showPasswordFields: boolean = false
}
